<template>
  <div class="media-content" v-loading="loading">
    <el-button
      type="primary"
      class="mw-add-button"
      @click="openEditWin('create')"
      >添加</el-button
    >
    <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="id" label="ID" width="100"> </el-table-column>
      <el-table-column prop="name" label="素材名称"> </el-table-column>
      <el-table-column prop="file_type" label="素材类型">
        <template slot-scope="scope">
          <span>{{ typeArr[scope.row.file_type] }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="fileUrl" label="素材路径"> </el-table-column>
      <el-table-column prop="created_at" label="创建时间"> </el-table-column>
      <el-table-column prop="update_at" label="更新时间"> </el-table-column>
      <el-table-column prop="edit" label="编辑" width="100">
        <template slot-scope="scope">
          <div class="edit-button">
            <i
              @click="openEditWin(scope.row)"
              class="el-icon-edit pointer mar-r10"
            ></i>
            <i
              class="el-icon-delete pointer"
              @click="delItem(scope.row.id)"
            ></i>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageInfo.page"
      :page-sizes="[10, 20, 30, 40, 50, 100]"
      :page-size="pageInfo.pageSize"
      layout="sizes, total, prev, pager, next, jumper"
      :total="cnt_all"
    >
    </el-pagination>

    <!--新增对话框-->
    <el-dialog
      class="dialog600"
      :title="editType === 'create' ? '添加素材文件' : '修改素材文件'"
      :visible.sync="dialogVisible"
      v-if="dialogVisible"
    >
      <el-form
        :model="editOne"
        label-position="left"
        label-width="100px"
        :rules="editOneRule"
      >
        <div class="user-info">
          <el-form-item label="素材名称" prop="name">
            <el-input v-model="editOne.name"></el-input>
          </el-form-item>
          <el-form-item label="素材类型" prop="file_type">
            <el-select
              placeholder="请选择素材类型"
              v-model="editOne.file_type"
              style="width: 100%"
            >
              <el-option v-for='(value,index) in typeArr' :label="value" :value="index" :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="视频上传" v-if="editOne.file_type===2">
            <el-upload
              ref="upload"
              name="file"
              class="avatar-uploader"
              :action="Mp4UploadAction()"
              :limit="1"
              :on-preview="handlePreview"
              :on-remove="handleRemove"
              :file-list="fileList"
              :on-success="handleAvatarSuccess"
              :beforeUpload="beforeAvatarUpload"
            >
              <el-button size="small" type="primary">点击上传素材</el-button>
            </el-upload>
          </el-form-item>
          <el-form-item label="图片上传" v-else-if="editOne.file_type===1">
            <el-upload
              ref="upload"
              name="file"
              class="avatar-uploader"
              :action="Mp4UploadAction()"
              :limit="1"
              :on-preview="handlePreview"
              :on-remove="handleRemove"
              :file-list="fileList"
              :on-success="handleAvatarSuccess"
              :beforeUpload="beforeAvatarUpload"
            >
              <el-button size="small" type="primary">点击上传素材</el-button>
            </el-upload>
          </el-form-item>
          <el-form-item label="文字编辑" v-else-if="editOne.file_type===0">
            <div class="form_box">
              <el-input
                type="textarea"
                placeholder="请输入内容,Enter可换行"
                class="textarea_s"
                show-word-limit
                autosize
                v-model="editOne.text_data"
                @input="getText">
              </el-input>
            </div>
            <div class="demo_box">
              <div class="demo_set">
                
              </div>
              <div class="textarea_box" v-html="textarea_data">
                <div class="textarea_con" v-html="textarea_data"></div>
              </div>
              
            </div>
            <div class="clear"></div>
          </el-form-item>
          
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="mw-edit-button" @click="dialogVisible = false"
          >取消</el-button
        >
        <el-button
          type="primary"
          @click="createMedia"
          v-if="editType === 'create'"
          >确 定</el-button
        >
        <el-button
          type="primary"
          @click="updateItem"
          v-if="editType === 'update'"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import manageApi from "@/api/message/mediaManage"
export default {
  data() {
    return {
      loading: false,
      dialogVisible: false,
      tableData: [],
      typeArr: ['文字','图片','视频'],
      pageInfo: {
        page: 1,
        pageSize: 20,
      },
      cnt_all: 0,
      editOneRule: {
        fileName: [{ required: true, message: "请输入素材名称", trigger: "blur" }],
      },
      editType: -1,
      editOne: {},
      textarea_data: '',
      fileList: [],
      file: "",
    };
  },
  methods: {
    Mp4UploadAction() {
      return process.env.VUE_APP_BASE_API+'/v1/mediaRoom/manager/uploadFile';
    },
    getTableData(pageIndex) {
      this.pageInfo.page = pageIndex;
      this.loading = true;
      manageApi.manageList(this.pageInfo).then((res) => {
        console.log('manageList',res)
        if (res.data.code === 1000) {
          this.loading = false;
          let resData = res.data.data;
          this.tableData = resData.list;
          this.pageInfo.page = pageIndex;
          this.cnt_all = parseInt(resData.count);
        }
      });
    },

    handleSizeChange(val) {
      this.pageInfo.pageSize = val;
      this.getTableData(this.pageInfo.page);
    },
    handleCurrentChange(val) {
      this.pageInfo.page = val;
      this.getTableData(this.pageInfo.page);
    },

    openEditWin(index) {
      if (index === "create") {
        this.editOne = {
          name: '',
          file_type: '',
          file_url: '',
          text_color: '',
          text_data: '',
          text_font: ''
        };
        this.editType = "create";
      } else {
        this.editOne = {
          id: index.id,
          name: index.name,
          file_type: index.file_type,
          file_url: index.file_url,
          text_color: index.text_color,
          text_data: index.text_data,
          text_font: index.text_font
        };
        this.editType = "update";
      }
      this.dialogVisible = true;
    },
    updateItem() {
      manageApi.manageEdit(this.editOne.id, this.editOne).then((res) => {
        if (res.data.code === 1000) {
          this.$message.success("修改成功");
          this.dialogVisible = false;
          this.getTableData(this.pageInfo.page);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    createItem() {
      manageApi.manageAdd(this.editOne).then((res) => {
        if (res.data.code === 1000) {
          this.$message.success("添加成功");
          this.dialogVisible = false;
          this.getTableData(this.pageInfo.page);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    delItem(id) {
      this.$confirm("本操作将永久删除该条信息，是否继续？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
      .then(() => {
        manageApi.manageDel(id).then((res) => {
          if (res.data.code === 1000) {
            this.$message.success("删除成功");
            this.getTableData(this.pageInfo.page);
          } else {
            this.$message.error(res.data.message);
          }
        });
      })
      .catch(() => {
        this.$message({
          type: "info",
          message: "已取消删除",
        });
      });
    },
    handleRemove(file, fileList) {
      // console.log(file, fileList);
    },
    handlePreview(file) {
      // console.log(file);
    },
    handleAvatarSuccess(res, file) {
      if (res.code === 1000) {
        this.$message.success("上传成功");
        this.editOne.md5 = res.data.md5;
        this.editOne.fileUrl = res.data.fileUrl;
      } else {
        this.$message.error("错误，" + res.message);
      }
    },
    beforeAvatarUpload(file) {
      var testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      // console.log('file',file)
      // console.log('testmsg',testmsg)
      // const extension = testmsg === "mp4";
      // console.log('extension',extension)
      if (testmsg==='mp4'||testmsg==='jpg'||testmsg==='png') {
        return true;
      }else{{
        this.$message({
          message: "上传文件只能是jpg、png图片和视频mp4格式！",
          type: "error",
        });
        return false;
      }}
      
    },
    getText(pretext){
      let returnText = pretext.replace(/\r\n/g, '<br/>').replace(/\n/g, '<br/>').replace(/\s/g, '&nbsp;')
      this.textarea_data = returnText
    }
  },
  mounted() {
    this.getTableData(this.pageInfo.page);
  },
};
</script>
<style lang='less'>
.media-content {
  width: 100%;
  .el-form-item__content{
	  height:auto !important;
  }
}
.textarea_s{
  .el-textarea__inner{
    text-align:center;
  }
}
.form_box{
  width:230px;
  float: left;
}
.demo_box{
  position: relative;
  width:200px;
  float: right;
  height:480px;
  background: #111;
  .textarea_con{
    width:200px;
    height:480px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #111;
    font-size: 20px;
    box-sizing: border-box;
    padding:10px;
    color:#fff;
    text-align: center;
  }
}

</style>